(function(){
  var popup=document.getElementById('limbik-shipping-popup');
  if(!popup || (window.Shopify && Shopify.designMode) || location.pathname==='/cart' || location.pathname.indexOf('/checkouts')===0) return;
  var key='limbik_shipping_popup_seen_regions_60000';
  try{if(sessionStorage.getItem(key)) return;}catch(e){}
  function closePopup(){
    popup.hidden=true;
    document.body.classList.remove('limbik-popup-open');
    try{sessionStorage.setItem(key,'1');}catch(e){}
  }
  popup.querySelectorAll('[data-limbik-popup-close]').forEach(function(el){el.addEventListener('click',closePopup);});
  popup.querySelector('.limbik-shipping-popup__cta').addEventListener('click',function(){
    try{sessionStorage.setItem(key,'1');}catch(e){}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape' && !popup.hidden) closePopup();});
  window.setTimeout(function(){
    popup.hidden=false;
    document.body.classList.add('limbik-popup-open');
    var closeButton=popup.querySelector('.limbik-shipping-popup__close');
    if(closeButton) closeButton.focus();
  },700);
})();